
export enum ObjectStatusEnum {
    none = 'Brak',
    safe = 'Bezpieczny',
    warning = 'Ostrzegawczy',
    alert = 'Alarmowy'
}
